import { createChatStore } from '../../../chat/core';

/**
 * The Lead-to-Cash monitor's chat — the shared chat store, one for the page.
 * Its title stays empty until the thread has one; the panel shows the
 * monitor's name meanwhile.
 */
export const useL2CChatStore = createChatStore(null);
